import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import FloatingChatButton from './FloatingChatButton';
import ComingSoon from '../common/ComingSoon';
import { SubscriptionRequiredBanner } from './SubscriptionRequiredBanner';
import { SubscriptionExpiryBanner } from './SubscriptionExpiryBanner';
import { BusinessHoursRequiredBanner } from './BusinessHoursRequiredBanner';
import { useAuth } from '../../context/AuthContextZustand';
import { DISABLE_BACKEND_CHATBOT_CALLS } from '../../services/chatConfig';
import { useEstablishmentTheme, useThemeMode } from '../../hooks/theme';
import { useEstablishmentData } from '../../hooks/settings';
import { useEstablishmentLoader } from '../../hooks/common/useEstablishmentLoader';
import { isEffectivePermissionsEmpty } from '../../constants/permissions';

interface LayoutProps {
  title: string;
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ title, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();

  // Garante establishment (logo, cores) carregado ao entrar na área autenticada; valida o slug com o backend
  useEstablishmentLoader();
  useEstablishmentTheme();
  useThemeMode();
  useEstablishmentData();

  const isPendingDev = isEffectivePermissionsEmpty(user?.permissions);

  return (
    <div
      className="fixed inset-0 flex overflow-hidden bg-gray-100 dark:bg-gray-900"
      data-testid="layout-authenticated"
    >
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-gray-100 dark:bg-gray-900">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} title={title} />

        <SubscriptionRequiredBanner />
        <SubscriptionExpiryBanner />
        <BusinessHoursRequiredBanner />

        <main
          tabIndex={0}
          className="min-h-0 min-w-0 flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 outline-none focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:ring-offset-2 dark:bg-gray-900 dark:focus-visible:ring-gray-500"
        >
          {isPendingDev ? (
            <ComingSoon
              title="Área em Desenvolvimento"
              description="Seu perfil ainda não possui permissões para esta área. Solicite acesso ao administrador."
              icon="settings"
            />
          ) : (
            <div className="min-w-0 max-w-full px-4 py-6 lg:px-8">{children}</div>
          )}
        </main>
      </div>

      {!DISABLE_BACKEND_CHATBOT_CALLS &&
        user?.permissions?.some((p) => ['iam.manage', 'appointments.read'].includes(p)) &&
        user?.establishmentWhatsAppEnabled && <FloatingChatButton />}
    </div>
  );
};

export default Layout;
